import { useState } from "react";
import axios from "axios";
import Helper from "@/helper";

const csrfToken = Helper.getCSRFToken();

const useBulkDelivery = () => {
  const [isLoading, setIsLoading] = useState(false);

  const sendBulkDelivery = async ({
    create_url,
    text,
    channels,
    chategy_customer_client_ids,
    scheduled_at = null,
    onSuccess,
    onError,
  }) => {
    setIsLoading(true);

    const payload = {
      bulk_delivery: {
        text,
        channels,
        chategy_customer_client_ids,
        ...(scheduled_at && { scheduled_at }),
      },
    };

    try {
      const response = await axios.post(create_url, payload, {
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
      });

      if (response.data.success) {
        onSuccess?.(response.data);
      } else {
        onError?.(response.data.errors);
      }
    } catch (error) {
      console.error(error);
      onError?.(error?.response?.data?.errors || {});
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    sendBulkDelivery,
  };
};

export default useBulkDelivery;
